/* ====================================================================
   IMPORTS
   ==================================================================== */

/* ==========================================================================
   PARCEL JS IMPORTS
   ========================================================================== */

import '../scss/_entry.scss';

/**
 * Dependency imports
 */

import ScrollReveal from 'scrollreveal';
import manageBehaviours from './modules/helpers/_manageBehaviours';
import resized from './modules/helpers/_resized';

// Alpine functions
import replaceBullets from './modules/helpers/_replaceBullets';
import recommendedShuffle from './modules/helpers/_recommendedShuffle';

/**
 * Behaviour imports
 */

import * as Behaviours from './modules/behaviours/_behaviours';


document.addEventListener('DOMContentLoaded', function () {
  /**
   * Initialise behaviours
   */
  manageBehaviours(Behaviours);
  HSC.Behaviours = Behaviours;

  const slideUp = {
    distance: '40px',
    origin: 'bottom',
    opacity: 0,
    duration: 800,
  };

  ScrollReveal().reveal('.scrollreveal', slideUp);

  // Scrollreveal

  //   const extractText = document.querySelector('.js-extract-text').innerHTML;

  //   console.log(extractText);

  //   const extractTest = extractText.extract('<p>[test]</p>', '<p>[/test]</p>');
  //   const extractkeyBenefits = extractText.extract('<p>[key_benefits]</p>', '<p>[/key_benefits]</p>');
  //   console.log(`test: ${extractTest}`);
  //   console.log(`keyBenefits: ${extractkeyBenefits}`);
});
